import { oz } from '@weft/utils';
import { NetSuiteOAuthDataSchema } from '../net-suite';
import { SalesforceOAuthDataSchema } from '../salesforce';
import { OAuth2DataSchema } from './oauth2-data-schema';

export const OAuthDataSchema = oz.union([
  OAuth2DataSchema,
  NetSuiteOAuthDataSchema,
  SalesforceOAuthDataSchema,
]).openapi('OauthData');

export type OAuthData = oz.infer<typeof OAuthDataSchema>;